module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NI6NZm/tc-custom/9781446350997.jpg?1725288188962",
      "alt": "This image is the cover for the book Just the Right Words"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Just the Right Words\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Find just the right words for your card with this unique collection of original sentiments and verses, plus motifs to add embellishment.")]), _c('br'), _c('br'), _vm._v("From witty and poignant one-liners to inspirational and heart-felt verses, this collection is guaranteed to bring joy to your heart and a smile to your face."), _c('br'), _c('br'), _vm._v("In addition, there are also numerous copyright-free motifs sprinkled throughout the occasion-themed chapters to add extra-special embellishment to your cards."), _c('br'), _c('br'), _vm._v("Find the right words for any occasion including:BirthdaysAnniversariesChristmasValentine’s DayLove & FriendshipNew HomeWeddingsGraduationsAcross the MilesNew BabySorryThank YouEaster & ReligiousChristeningsMother’s DayFather’s DayGood LuckNew JobGet WellSympathy"), _c('br'), _c('br'), _vm._v("Whatever you want to say, say it with the help of this charming and entertaining book.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Judith Wibberley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Judith Wibberley ran a craft center for many years and now sells creative craft supplies online. Her first booklet of verses was a hit with UK crafters. She currently lives in Devon, in the United Kingdom.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0